import { render, staticRenderFns } from "./cancel-prescription-dialog.vue?vue&type=template&id=65d17f48&scoped=true&lang=pug&"
import script from "./cancel-prescription-dialog.vue?vue&type=script&lang=ts&"
export * from "./cancel-prescription-dialog.vue?vue&type=script&lang=ts&"
import style0 from "./cancel-prescription-dialog.vue?vue&type=style&index=0&id=65d17f48&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d17f48",
  null
  
)

export default component.exports